import { API } from "../auth/authApi";

export const getEventLocationsApi = (params) => {
  return API.get("/event-location", { params });
};

export const createEventLocationApi = (data) => {
  const formData = new FormData();

  formData.append("name", data.name);
  formData.append("description", data.description);
  formData.append("thumbnail", data.thumbnail);
  formData.append("date", data.date);

  formData.append("venueName", data.venueName);
  formData.append("address1", data.address1);
  formData.append("address2", data.address2 || "");
  formData.append("city", data.city);
  formData.append("state", data.state);
  formData.append("country", data.country);
  formData.append("pincode", data.pincode);
  formData.append("latitude", data.latitude);
  formData.append("longitude", data.longitude);

  if (data.venueImage) {
    formData.append("venueImage", data.venueImage);
  }

  return API.post("/event-location", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteEventLocationApi = (id) => {
  return API.delete(`/event-location/${id}`);
};

export const updateEventLocationApi = (id, data) => {
  const formData = new FormData();

  formData.append("name", data.name);
  formData.append("description", data.description);
  formData.append("date", data.date);

  formData.append("venueName", data.venueName);
  formData.append("address1", data.address1);
  formData.append("address2", data.address2 || "");
  formData.append("city", data.city);
  formData.append("state", data.state);
  formData.append("country", data.country);
  formData.append("pincode", data.pincode);
  formData.append("latitude", data.latitude);
  formData.append("longitude", data.longitude);

  if (data.thumbnail) {
    formData.append("thumbnail", data.thumbnail);
  }

  if (data.venueImage) {
    formData.append("venueImage", data.venueImage);
  }

  return API.put(`/event-location/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const toggleEventLocationStatusApi = (locationId) => {
  return API.put(`/event-location/${locationId}/toggle-status`);
};

/* LOCATION TYPE */

export const createEventLocationTypeApi = (data) => {
  return API.post("/event-location/type", data);
};

export const updateEventLocationTypeApi = (eventTypeId, data) => {
  return API.put(`/event-location/type/${eventTypeId}`, data);
};

export const getEventLocationTypesApi = (params) => {
  return API.get("/event-location/type", { params });
};
